import { CreateContainer } from "./ContainerCreate";
import LoadMoreContainer from "./LoadMoreContainer";
import { getQuotesAll } from "../api/getQuotes";

class QuotesContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: true, items: [] };
  }
  fetch = () => {
    this.props.request(this.state.page).then((data) => {
      console.log("🚀 ~ file: QuotesContainer.js ~ line 12 ~ QuotesContainer ~ this.props.request ~ data", data);
      const hasMore = true;
      const items = this.state.items.slice(0);
      data.data.quotes.map((t) => items.push(t));
      this.setState({ items, page: (this.state.page += 1), hasMore });
    });
  };
}

QuotesContainer.defaultProps = {};
export default CreateContainer(getQuotesAll, QuotesContainer);
